export default [
  {
    amount: "INR 10",
    cardbill: "Credit",
    remark: "-",
    creditcard: "29 Oct 2021 16:27:54",
    ip: "103.209.143.135",
  },
  {
    amount: "INR 10",
    cardbill: "Credit",
    remark: "-",
    creditcard: "29 Oct 2021 16:27:54",
    ip: "103.209.143.135",
  },
];
